<template>
    <div>
        <div class="tabs">
            <ul>
                <li v-for="(tab, index) in tabs" :key="index" :class="{ 'is-active': tab.isActive }">
                    <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>
        <div class="tabs-details">
            <slot></slot>
        </div> 
    </div>
</template>
<script>

export default {
    name: 'tabs',
    data () {
        return {
            tabs: []
        }
    },
    created() {
        this.tabs = this.$children;
    },
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.name == selectedTab.name);
            });
        }
    }
}
</script>
<style lang="scss"  >
    .tabs{
        position: relative;
        ul{
            display: flex;
            margin-bottom: 8px;
            li{
                margin-right: 30px;
                a{
                    font-size: 16px;
                    color: #a8a5a4;
                }
            }
            li.is-active{
                a{
                    color: #292625;
                }
                :after{
                    content: '';
                    position: absolute;
                    display: block;
                    height: 4px;
                    width: 20px;
                    bottom: -10px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/Tabs.vue